"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsciiStreamParser = exports.ASCII_ICON_STORAGE_HEADER = void 0;
const Util_1 = require("../../../../../Util");
const PropertyParser_1 = require("../PropertyParser");
exports.ASCII_ICON_STORAGE_HEADER = '|HEADER=Icon storage';
class AsciiStreamParser {
    constructor(lines) {
        this.lines = lines;
    }
    static async fromBlob(blob) {
        const text = (0, Util_1.bytesToLatin1)(new Uint8Array(await blob.arrayBuffer()));
        const lines = text.split(/\r?\n/).filter((line) => line.trim().length > 0);
        return new AsciiStreamParser(lines);
    }
    parseStorage() {
        return Promise.resolve(undefined);
    }
    parseFileHeader() {
        const records = [];
        for (const line of this.lines) {
            if (line === exports.ASCII_ICON_STORAGE_HEADER) {
                continue;
            }
            const properties = this.parseLine(line);
            records.push(properties);
        }
        return Promise.resolve(records);
    }
    parseAdditional() {
        throw new Error('ASCII schematic files do not support Additional streams');
    }
    parseLine(line) {
        return PropertyParser_1.PropertyParser.parsePropertyPairs(line);
    }
}
exports.AsciiStreamParser = AsciiStreamParser;
//# sourceMappingURL=AsciiStreamParser.js.map